import React, { useState, useEffect } from 'react';

import { APP_URL } from 'types';
import { SideNavLink } from 'carbon-components-react';
import {
  WatsonHealthMagnify16,
  Email16,
  ReportData16
} from '@carbon/icons-react';
import { useHistory } from 'react-router-dom';

export const LeftNavAOViewer: React.FC<any> = () => {
  const history = useHistory();
  const [pathname, setPathname] = useState<string>(history?.location?.pathname);

  useEffect(() => {
    history && setPathname(history.location?.pathname);
  }, [history]);
  return (
    <>
      <div className="divider" />
      {/* Reporting */}
      <SideNavLink
        aria-current={pathname === APP_URL.REPORTS ? 'page' : undefined}
        renderIcon={ReportData16}
        onClick={() => history.push(`${APP_URL.REPORTS}`)}
      >
        Reporting
      </SideNavLink>
      {/* REFERRAL_HISTORY */}
      <SideNavLink
        renderIcon={WatsonHealthMagnify16}
        aria-current={
          pathname === APP_URL.REFERRAL_HISTORY ? 'page' : undefined
        }
        onClick={() => history.push(`${APP_URL.REFERRAL_HISTORY}`)}
      >
        Referral history
      </SideNavLink>
      <SideNavLink
        renderIcon={Email16}
        aria-current={
          pathname === APP_URL.REFERRALS_EMAILS ? 'page' : undefined
        }
        onClick={() => history.push(`${APP_URL.REFERRALS_EMAILS}`)}
      >
        Email history
      </SideNavLink>
      <div className="divider" />
    </>
  );
};

export default LeftNavAOViewer;
